import { render, staticRenderFns } from "./ReportsSidebar.vue?vue&type=template&id=5668b766&scoped=true&"
import script from "./ReportsSidebar.vue?vue&type=script&lang=ts&"
export * from "./ReportsSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./ReportsSidebar.vue?vue&type=style&index=0&id=5668b766&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5668b766",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/cypher.team.viz/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5668b766')) {
      api.createRecord('5668b766', component.options)
    } else {
      api.reload('5668b766', component.options)
    }
    module.hot.accept("./ReportsSidebar.vue?vue&type=template&id=5668b766&scoped=true&", function () {
      api.rerender('5668b766', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ReportsSidebar.vue"
export default component.exports